import React, { useState } from "react";
import {
	Alert,
	Box,
	Button,
	CircularProgress,
	Modal,
	Snackbar,
	Typography,
} from "@mui/material";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar } from "react-modern-calendar-datepicker";
import axios from "axios";
import constants from "../Constants";
import ReportExcel from "../component/ReportExcel";
import moment from "moment-jalaali";
import FormatHelper from "../helper/FormatHelper";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	bgcolor: "background.paper",
	boxShadow: 24,
	p: 4,
};

export default function ReportModal({ open, setOpen }) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(null);
	const [columns, setColumns] = useState(null);
	const [message, setMessage] = useState(false);
	const [selectedDayRange, setSelectedDayRange] = useState({
		from: null,
		to: null,
	});

	var groupBy = function (xs, key) {
		return xs.reduce(function (rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	};

	const handleClose = () => {
		setMessage(false);
	};

	const reportExcel = async () => {
		try {
			if (!selectedDayRange.from || !selectedDayRange.to) {
				setMessage({
					type: "warning",
					content: "تاریخ صحیح نیست",
				});
				return;
			}

			setLoading(true);
			let data = [];
			const res = await axios.post(
				constants.baseUrl + "/school/report",
				{
					from: FormatHelper.toEnglishString(
						`${moment(
							selectedDayRange.from.year +
								"/" +
								selectedDayRange.from.month +
								"/" +
								selectedDayRange.from.day,
							"jYYYY/jMM/jDD"
						).format("YYYY-MM-DD")}`
					),
					to: FormatHelper.toEnglishString(
						`${moment(
							selectedDayRange.to.year +
								"/" +
								selectedDayRange.to.month +
								"/" +
								selectedDayRange.to.day,
							"jYYYY/jMM/jDD"
						)
							.add(1, "days")
							.startOf("day")
							.format("YYYY-MM-DD")}`
					),
				},
				{
					headers: {
						authorization: "Bearer " + localStorage.getItem("schoolToken"),
					},
				}
			);
			if (res.data.status === 202) {
				//group by users
				const users = groupBy(res.data.result.report, "userId");
				let row = {};
				let courseTypes = {};
				let courses = {};
				let columns = {};
				Object.keys(users).forEach(userId => {
					row = {};
					columns[users[userId][0].gradeName] =
						columns[users[userId][0].gradeName] === undefined
							? []
							: columns[users[userId][0].gradeName];
					//get all performances
					row["رشته تحصیلی"] = users[userId][0].gradeName;
					row["دانش آموز"] =
						users[userId][0].userFirstName + " " + users[userId][0].userLastName;
					columns[users[userId][0].gradeName].indexOf("دانش آموز") < 0 &&
						columns[users[userId][0].gradeName].push("دانش آموز");

					row["مشاور"] =
						users[userId][0].advisorFirstName +
						" " +
						users[userId][0].advisorLastName;
					columns[users[userId][0].gradeName].indexOf("مشاور") < 0 &&
						columns[users[userId][0].gradeName].push("مشاور");

					row["ساعت کل مطالعه"] = users[userId].reduce((p, x) => {
						return p + (x.reportStudyQuantity || x.reportTestQuantity);
					}, 0);
					columns[users[userId][0].gradeName].indexOf("ساعت کل مطالعه") < 0 &&
						columns[users[userId][0].gradeName].push("ساعت کل مطالعه");

					row["تعداد کل عملکرد"] = users[userId].length;
					columns[users[userId][0].gradeName].indexOf("تعداد کل عملکرد") < 0 &&
						columns[users[userId][0].gradeName].push("تعداد کل عملکرد");

					row["تعداد تست کل"] = users[userId].reduce((p, x) => {
						return p + (x.reportTestCount ? x.reportTestCount : 0);
					}, 0);
					columns[users[userId][0].gradeName].indexOf("تعداد تست کل") < 0 &&
						columns[users[userId][0].gradeName].push("تعداد تست کل");

					courseTypes = groupBy(users[userId], "courseTypeName");
					//group by according to courseTypeName
					Object.keys(courseTypes).forEach(key => {
						row["مجموع " + key] = courseTypes[key].reduce((p, x) => {
							return p + (x.reportStudyQuantity || x.reportTestQuantity);
						}, 0);
						columns[users[userId][0].gradeName].indexOf("مجموع " + key) < 0 &&
							columns[users[userId][0].gradeName].push("مجموع " + key);

						row["تعداد تست کل  " + key] = courseTypes[key].reduce((p, x) => {
							return p + (x.reportTestCount ? x.reportTestCount : 0);
						}, 0);
						columns[users[userId][0].gradeName].indexOf("تعداد تست کل  " + key) < 0 &&
							columns[users[userId][0].gradeName].push("تعداد تست کل  " + key);
					});

					courses = groupBy(users[userId], "courseName");
					//group by according to courseName
					Object.keys(courses).forEach(key => {
						row["مجموع ساعت درس  " + key] = courses[key].reduce((p, x) => {
							return p + (x.reportStudyQuantity || x.reportTestQuantity);
						}, 0);
						columns[users[userId][0].gradeName].indexOf("مجموع ساعت درس  " + key) <
							0 && columns[users[userId][0].gradeName].push("مجموع ساعت درس  " + key);

						row["تعداد تست درس " + key] = courses[key].reduce((p, x) => {
							return p + (x.reportTestCount ? x.reportTestCount : 0);
						}, 0);
						columns[users[userId][0].gradeName].indexOf("تعداد تست درس " + key) < 0 &&
							columns[users[userId][0].gradeName].push("تعداد تست درس " + key);
					});

					data.push(row);
				});
				setColumns(columns);
				setData(groupBy(data, "رشته تحصیلی"));
			} else {
				setMessage({
					type: "warning",
					content: res.data.result.message,
				});
			}
			setLoading(false);
		} catch (error) {
			console.log(error);
			setLoading(false);
		}
	};

	return (
		<Modal
			open={open}
			onClose={() => {
				setOpen(false);
				setData(null);
				setMessage(false);
			}}>
			<Box
				sx={{ ...style, borderRadius: 2, minWidth: 400 }}
				className="d-flex-column">
				<Typography mb={2} fontSize={16} fontWeight={"bold"}>
					انتخاب بازه ی زمانی
				</Typography>
				<Calendar
					shouldHighlightWeekends
					locale={"fa"}
					value={selectedDayRange}
					onChange={setSelectedDayRange}
					colorPrimary="#35284a"
				/>
				{loading ? (
					<Button sx={{ mt: 2 }} variant="outlined" color="primary">
						<CircularProgress size={20} />
					</Button>
				) : (
					<Button
						sx={{ mt: 2, fontSize: 16 }}
						onClick={reportExcel}
						variant="outlined"
						color="primary">
						گزارش اکسل
					</Button>
				)}
				{data && <ReportExcel setData={setData} data={data} columns={columns} />}
				<Snackbar
					anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
					open={message}
					autoHideDuration={6000}
					onClose={handleClose}>
					<Alert
						onClose={handleClose}
						severity={message.type || "warning"}
						sx={{ width: "100%", direction: "ltr" }}>
						{message.content}
					</Alert>
				</Snackbar>
			</Box>
		</Modal>
	);
}
